import { render, staticRenderFns } from "./AddProperty.vue?vue&type=template&id=36c8c7e8"
import script from "./AddProperty.vue?vue&type=script&lang=js"
export * from "./AddProperty.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/property.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports